import React, { Fragment } from 'react';
import { View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { TextArea } from './TextArea';

storiesOf('Form', module).add('TextArea', () => (
  <Fragment>
    <PanelHeader>✉️ TextArea</PanelHeader>
    <PlatformPadding vertical horizontal>
      <View>
        <TextArea placeholder="Enter description" />
      </View>
    </PlatformPadding>
    <PlatformPadding vertical horizontal>
      <View>
        <TextArea placeholder="Some predefined text..." disabled />
      </View>
    </PlatformPadding>
  </Fragment>
));
